class PreNextButtons extends HTMLElement {
  connectedCallback() {
    this.prevBtn = this.querySelector('.prev-button');
    this.nextBtn = this.querySelector('.next-button');
    
    // scroller là sibling gần nhất chứa danh sách sản phẩm — chỉnh selector đúng theo cấu trúc thật của bạn
    //this.scroller = this.closest('.product-list__inner--scroller')?.querySelector('.product-list__inner')
    //  || this.parentElement.querySelector('[data-scroller]');

    this.scroller = this.closest('.product-list__inner--scroller');

    if (!this.scroller || !this.prevBtn || !this.nextBtn) return;

    this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
    this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
    this.scroller.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    window.addEventListener('resize', () => this.updateButtons());

    this.updateButtons();
  }

  scrollByCard(direction) {
    const card = this.scroller.querySelector('.product-card');
    const cardWidth = card ? card.getBoundingClientRect().width : this.scroller.clientWidth;
    const gap = parseFloat(getComputedStyle(this.scroller).gap) || 0;
    this.scroller.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
  }

  updateButtons() {
    const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
    this.prevBtn.disabled = this.scroller.scrollLeft <= 0;
    this.nextBtn.disabled = this.scroller.scrollLeft >= maxScroll - 1;
  }
}

customElements.define('pre-next-buttons', PreNextButtons);